"use strict";

PF.Observer = class Observer extends PF.Widget
	{
	constructor()
		{
		if (arguments.length == 1)
			{
			super(arguments);
			}
		else
			{
			super({
				dom: {element: arguments[0]},
				callback: arguments[1],
				config: arguments[2] || {}
			});
			}
		}

	static get options()
		{
		return {
			dom: {
				element: null,
			},
			callback: () => {
			},
			config: {
				childList: true,
				attributes: true,
				characterData: true,
				subtree: true
			},
		};
		}

	init()
		{
		this.observer = new MutationObserver(this.callback);
		// this.dom.element.find('img').on('load', this.callback);
		}

	start()
		{
		this.observer.observe(this.dom.element.node, this.config);
		}

	stop()
		{
		this.observer.disconnect();
		}
	};


PF.HeightObserver = class HeightObserver extends PF.Observer
	{
	init()
		{
		this.height = this.dom.element.height();
		// super.init();
		this.observer = new MutationObserver(this.checkHeight.bind(this));
		}

	checkHeight()
		{
		if (this.height !== this.dom.element.height())
			{
			this.height = this.dom.element.height();
			this.callback();
			}
		}
	};

PF.WidthObserver = class WidthObserver extends PF.Observer
	{
	init()
		{
		this.width = this.dom.element.width();
		this.observer = new MutationObserver(this.checkWidth.bind(this));
		}

	checkWidth()
		{
		if (this.width !== this.dom.element.width())
			{
			this.width = this.dom.element.width();
			this.callback();
			}
		}
	};
